module.exports = __webpack_public_path__ + "static/media/verset_corner_upper_left.68ce8934.png";